import { HowItWorks5StepsDetailedCard } from "./HowItWorks5StepsDetailedCard";

export { HowItWorks5StepsDetailedCard };
